import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showOverlay, hideOverlay } from 'store/overlay/actions';
import Keyboard from '../components/Keyboard';

export class KeyboardContainer extends Component {
  render() {
    return <Keyboard {...this.props} />;
  }
}

export const mapDispatchToProps = {
  showOverlay,
  hideOverlay,
};

const mapStateToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeyboardContainer);
